/**
 * DiagramNodeIconBadge - the logo / initials chip on an architecture box (System Architecture and
 * the System map). Which icon a box gets is decided by `diagramNodeIcon`.
 */

import type { DiagramNodeIcon } from '../utils/diagramNodeIcon';

export function DiagramNodeIconBadge({ icon }: { icon: DiagramNodeIcon }) {
  return (
    <div
      className={`bpr-diagram-node__icon${icon.logo ? '' : ' bpr-diagram-node__icon--initials'}`}
      aria-hidden="true"
    >
      {icon.logo ? (
        <img className="bpr-diagram-node__logo" src={icon.logo} alt="" />
      ) : (
        <span className="bpr-diagram-node__initials">{icon.initials}</span>
      )}
    </div>
  );
}
